export const siteInfo = {
  name: "网报吃瓜",
  slogan: "只搬运官方原文，把碎片还原成时间线",
  intro:
    "网报吃瓜专注收录热传事件对应的官方通报、声明、回应与辟谣原文，按时间顺序整理成可复盘的时间线。遇到一件事，先看官方有没有发声、原文怎么说、后续进展到哪一步，再决定要不要转发。",
  email: "contact@wangbao-chigua.site",
  period: "每日 08:00 — 23:00 更新",
};

export const siteStats = [
  { label: "已收录事件", value: "326", unit: "件" },
  { label: "官方通报原文", value: "1480", unit: "条" },
  { label: "辟谣与澄清", value: "412", unit: "条" },
  { label: "平均还原时长", value: "36", unit: "小时" },
];

export const principles = [
  {
    icon: "ri-link-m",
    title: "只挂原文与出处",
    desc: "每条时间线都标注发布主体、发布时间与来源类型。二手转述一律不作为结论依据。",
  },
  {
    icon: "ri-time-line",
    title: "按时间顺序还原",
    desc: "把传言、回应、通报、辟谣、进展按时间轴排列，前后因果一眼看清。",
  },
  {
    icon: "ri-shield-check-line",
    title: "区分结论与进展",
    desc: "明确区分「最终通报」与「阶段性进展」，不把调查中的说法写成定论。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新不删帖",
    desc: "事件有新发展就追加节点，保留旧节点并标注更新时间，方便对照复盘。",
  },
];

export const audiences = [
  { title: "普通网友", desc: "想快速弄明白一件事官方到底怎么说，不想被标题带节奏。" },
  { title: "内容创作者", desc: "需要上稿前核实关键节点、引用官方原文与准确时间。" },
  { title: "社群管理员", desc: "遇到群里转发的不确定消息，需要一条可复制的辟谣依据。" },
  { title: "关注公共事务的人", desc: "希望看到一件事从传言到结论的完整演变过程。" },
];

export const testimonials = [
  {
    name: "陈同学",
    role: "高校在读",
    text: "宿舍群里传停水的时候，我直接把时间线甩进群，三分钟就没人再转了，比自己解释半天好用。",
  },
  {
    name: "老周",
    role: "自媒体编辑",
    text: "写稿最怕时间点写错。这里把每条通报的主体和时间都列出来了，引用的时候心里有底。",
  },
  {
    name: "阿岚",
    role: "社区运营",
    text: "辟谣专区真的省事，遇到不确定的消息先搜一下，有官方原文就转，没有就先按住不发。",
  },
  {
    name: "王女士",
    role: "学生家长",
    text: "校门口那条传言我当天看到就慌了，第二天官方结案说明出来，这里整理得特别清楚。",
  },
];

export const updateProcess = [
  { step: "01", title: "监测热传信息", desc: "抓取多平台快速传播的碎片信息与截图，记录最初形态与传播时间。" },
  { step: "02", title: "核对官方发声", desc: "逐一查证相关部门、企业官方账号是否发声，确认原文与发布日期。" },
  { step: "03", title: "整理时间线", desc: "按时间顺序排列传言、回应、通报、辟谣与进展，标注发布主体。" },
  { step: "04", title: "持续跟踪更新", desc: "有新通报就追加节点并更新修改时间，旧节点保留不做覆盖。" },
];